module.exports = __webpack_public_path__ + "img/Flag_of_the_Marshall_Islands.af1a71bc.svg";